import "./App.css";
import { lazy, Suspense } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";

import RouteLoadingFallback from "./components/layout/RouteLoadingFallback";

const PublicRoutes = lazy(() => import("./routes/publicRoutes"));
const ExamRoutes = lazy(() => import("./routes/examRoutes"));
const EvalrisRoutes = lazy(() => import("./routes/evalrisRoutes"));
const AdminRoutes = lazy(() => import("./routes/adminRoutes"));

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route
          path="/app/evalris/*"
          element={
            <Suspense fallback={<RouteLoadingFallback />}>
              <EvalrisRoutes />
            </Suspense>
          }
        />
        <Route
          path="/app/*"
          element={
            <Suspense fallback={<RouteLoadingFallback />}>
              <AdminRoutes />
            </Suspense>
          }
        />
        <Route
          path="/assessment-exam"
          element={
            <Suspense fallback={<RouteLoadingFallback />}>
              <ExamRoutes page="exam" />
            </Suspense>
          }
        />
        <Route
          path="/exam-access/:inviteId"
          element={
            <Suspense fallback={<RouteLoadingFallback />}>
              <ExamRoutes page="access" />
            </Suspense>
          }
        />
        <Route
          path="/*"
          element={
            <Suspense fallback={<RouteLoadingFallback />}>
              <PublicRoutes />
            </Suspense>
          }
        />
      </Routes>
    </HashRouter>
  );
}

export default App;
